<template>
  <nav class="primary align-center dark d-flex flex-row" >
    <v-app-bar-nav-icon class="top-icon ml-2" @click="drawer = true"></v-app-bar-nav-icon>
    <v-toolbar-title class="pl-2 mt-2 "  >{{title}}</v-toolbar-title>
    <div class="pl-2 mt-2  service" v-if="isLoggedIn">
        <div class="text-font text-thin text-right mb-0 pr-5 service-log">  {{profile.name}} </div>
    </div>
    <v-navigation-drawer class="pt-5 pa-1"
      v-model="drawer"
        absolute
        temporary
           color="secondary"
    >
      <v-list
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="red--text text--accent-4"
        >
        <router-link to="/" style="text-decoration:none;">

          <v-img
          :src="require('../assets/logo.svg')"
          width="220" class="mb-1 mt-5 ml-3"
         />

          <v-spacer></v-spacer>
        </router-link>

          <div class="pa-4 profile" v-if="isLoggedIn">
             <h1 class="title-font text-normal text-left  mb-0">  {{profile.name}} </h1>
              <p class="subtitle-text text-left ma-0">  {{profile.owner}} </p>
          </div>

        <div class="pt-4">
          <router-link to="/bodovi" style="text-decoration:none;">
          <v-list-item v-if="isLoggedIn">
            <v-list-item-icon>
              <v-icon >mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Vaši bodovi</v-list-item-title>
          </v-list-item>
          </router-link>
          <router-link to="/informacije" style="text-decoration:none;">
          <v-list-item v-if="isLoggedIn">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title >Vaši podaci</v-list-item-title>
          </v-list-item>
          </router-link>
          <router-link to="/dobavljaci" style="text-decoration:none;">
           <v-list-item v-if="isLoggedIn">
            <v-list-item-icon>
              <v-icon>mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Vaši dobavljači</v-list-item-title>
          </v-list-item>
          </router-link>
          <router-link to="/istorija" style="text-decoration:none;">
           <v-list-item v-if="isLoggedIn">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Vaša istorija</v-list-item-title>
          </v-list-item>
          </router-link>
          <v-list-item v-if="isLoggedIn" @click="logout" >
            <v-list-item-icon>
              <v-icon >mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Odjavite se</v-list-item-title>
          </v-list-item>
          <router-link to="/registracija" style="text-decoration:none;">
          <v-list-item v-if="!isLoggedIn" >
            <v-list-item-icon style="margin-top: 6px;">
            <v-icon>mdi-lock-open</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Registracija / Prijava</v-list-item-title>
          </v-list-item>
          </router-link>
          <router-link to="/uslovi" style="text-decoration:none;">
           <v-list-item v-if="!isLoggedIn">
            <v-list-item-title>Uslovi korišćenja</v-list-item-title>
          </v-list-item>
          </router-link>
      </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    </nav>
</template>
<script>
  import firebase from 'firebase'
  import {fb , db} from '../main'
  
  export default {
    name: 'Navbar',
    data: () => ({
       drawer: false,
       isLoggedIn:false,
       currentUser:false,
       title:document.title,
       profile: {
         name: null,
         owner: null
       }
    }),
    created() {
      if(firebase.auth().currentUser) {
        this.isLoggedIn = true,
        this.currentUser = firebase.auth().currentUser.uid
      }
    },
    firestore() {
      const user = fb.auth().currentUser
      return {
        profile: db.collection('accounts').doc(user.uid),
      }
    },
    methods: {        
      logout: function(){
        firebase.auth().signOut().then(() => {
          this.$router.push('/')
        })
      }
      
    },
  }
</script>

<style>
  aside {
      width:286px!important;
  }
  .v-list-item {
      margin: 10px 0;
  }
  .v-toolbar__title, .v-btn__content i::before  {
    color: #ffffff;
  }
  nav {
    height: 56px;
  }
   .v-toolbar__title {
     width: 100%;
   }
  .profile {
    border-bottom: 1px solid #A7ADB1;
  }
  .service {
    display: block;
    width: 40%;
    position: relative;
  }
  .service-log {
    font-size: 1.25rem;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ffffff!important;
    font-weight: 100!important;
    font-size: 20px;
  }
  @media only screen and (max-device-width: 414px) {
  .v-toolbar__title,  .service div {
    font-size: 18px!important;
  }

  }
    @media only screen and (max-device-width: 375px) {
    .v-toolbar__title,  .service div {
      font-size: 16px!important;
    }
  }
   @media only screen and (max-device-width: 320px) {
    .v-toolbar__title,  .service div {
      font-size: 14px!important;
    }
  }
</style>